import { AccountValues, DeviceValues, accountOptions, deviceOptions } from "Components/Report/OnDemand/Filter";
import { useAppSelector } from "store/hook";
import { ReportDeviceStatus, ReportAccountStatus } from "Utility/Types/report";
import { DateToFormattedString } from "Components/Report/Periodic/Reports";
import { ChartTitle } from "./ChartCard";
import moment from "moment";

export type Parameter = AccountValues | DeviceValues;

const getXaxis = (unit: number, data: ReportDeviceStatus[] | ReportAccountStatus[]) => {
  if (!data) {
    return;
  }

  switch (unit) {
    case 3600: //hour : available for single day
      return data.map((item) => new Date(item.start_utc * 1000).getHours());
    case 86400: //date: week, month
      return data.map(
        (item) => `${new Date(item.start_utc * 1000).getMonth() + 1}/${new Date(item.start_utc * 1000).getDate()}`
      );
    case 604800: //week: month
      return Array.from({ length: data.length }, (_, i) => i + 1);
    case 2592000: //month: ??
      return Array.from({ length: data.length }, (_, i) => i + 1);
    default:
      console.log("erro axis input");
  }
};

const getXUnit = (unit: number) => {
  switch (unit) {
    case 3600: //hour : available for single day
      return "Hour";
    case 86400: //day: week, month
      return "Date";
    case 604800: //week: month
      return "Week";
    case 2592000: //month: ??
      return "Month";
    default:
      console.log("erro unit input");
  }
};

export const useChartParam = (param: Parameter, id: string, data?: any, name?: string) => {
  const { resportSetting, filterForm, onViewingDevice_Period } = useAppSelector((status) => status.report);
  const { isDarkMode } = useAppSelector((state) => state.global);
  const unit = onViewingDevice_Period?.unit ?? filterForm.unit;
  const Xaxis = getXaxis(unit, data);
  const Xunit = getXUnit(unit);
  const type = param.includes("account") ? "Account" : "Device";
  const label = [...accountOptions, ...deviceOptions].find((opt) => opt.value === param)!.label;
  const title = ChartTitle(type, label, id, name);
  const Yunit = Boolean(id) ? "Count" : "Unit";
  const param1 = `${param}_${id}`;
  const Ymax = resportSetting[param1];
  const Y2max = resportSetting[`${param}_2`];

  return { Ymax, Y2max, Yunit, title, Xaxis, Xunit, isDarkMode };
};

// + '<br/>'
export const hoverFormat = (params: any, data: any) => {
  const onHoverData = (data || [])[params[0].dataIndex];
  let header =
    "<h2 style='display:flex;align-items:center;'>" +
    moment(onHoverData.start_utc * 1000).format("MMMM Do YYYY, HH:mm:ss Z") +
    "<br/>" +
    moment(onHoverData.end_utc * 1000).format("MMMM Do YYYY, HH:mm:ss Z") +
    "</h2>";
  let content = "";
  params.forEach((item: any) => {
    content +=
      "<div style='display:flex;align-items:center;'>" +
      item.marker +
      item.seriesName +
      "：" +
      // "￥" +
      item.value +
      "</div>";
  });
  let str = " ";
  str =
    '<div style="width:100%;padding:5px;font-size:13px;box-sizing:border-box;border-radius:4px;position:relative;background:white">' +
    header +
    content +
    "</div>";
  return str;
};
